export const COOKIE_NAME = "klolklo";

export const USER_STORAGE_NAME = "user";
export const QUESTIONNAIRE_STORAGE_NAME = "questions";
export const RISK_LEVEL_STORAGE_NAME = "riskLevel";

export const STOP_TIME_STORAGE_NAME = "stop";